import { createAction, props } from '@ngrx/store';
import { PackInFocusState } from './pack-in-focus.models';

export const setPackInFocus = createAction('Set pack in focus', props<PackInFocusState>());

export const clearPackInFocus = createAction('Clear pack in focus');
